import { MAX_Z_INDEX } from "@/shared/utils/constant";
import ReactSelect from "react-select";
import useIsMobileHook from "../../shared/hooks/useIsMobileHook";
import NativeSelect from "./NativeSelect";
import { useTranslation } from "react-i18next";

const Select = ({
  isMobileNative = false,
  oneLine = false,
  label,
  onChange,
  placeholder,
  classNamePrefix = "react-select" as string,
  ...props
}: any) => {
  const { t } = useTranslation("");
  const isMobile = useIsMobileHook();

  return isMobile && isMobileNative ? (
    <div
      className="items-center md:block w-full"
      style={{
        display: oneLine ? "flex" : "block",
        width: oneLine ? "100%" : undefined,
      }}
    >
      {label && (
        <div
          className="font-semibold md:mb-[1rem]"
          style={{
            marginBottom: !oneLine ? "1rem" : undefined,
            marginRight: oneLine ? "1rem" : undefined,
          }}
        >
          {label}
        </div>
      )}

      <NativeSelect
        onChange={(e) =>
          onChange(
            props?.options?.find(
              (option) =>
                props?.getOptionValue(option) == e.target.value ||
                option.value == e.target.value
            )
          )
        }
        classNamePrefix={classNamePrefix}
        placeholder={placeholder ?? t("select")}
        {...props}
      />
    </div>
  ) : (
    <div
      className="items-center md:block w-full"
      style={{
        display: oneLine ? "flex" : "block",
        width: oneLine ? "100%" : undefined,
      }}
    >
      {label && (
        <div
          className="font-semibold md:mb-[1rem]"
          style={{
            marginBottom: !oneLine ? "1rem" : undefined,
            marginRight: oneLine ? "1rem" : undefined,
          }}
        >
          {label}
        </div>
      )}

      <ReactSelect
        onChange={onChange}
        classNamePrefix={classNamePrefix}
        noOptionsMessage={() => t("noOptions")}
        styles={{
          container: (base) => ({
            ...base,
            width: oneLine ? "100%" : base.width,
            background: "var(--input)",
          }),
          control: (base, state) => ({
            ...base,
            background: "var(--input)",
            boxShadow:
              props?.error !== undefined
                ? "0 0 0 0.3rem rgb(244 67 54 / 25%)"
                : "0 2px 8px #999",
            borderColor: state.isFocused ? "var(--primary)" : base.borderColor,
            "&:hover": {
              borderColor: "var(--primary)",
            },
          }),
          menu: (base) => ({
            ...base,
            background: "var(--input)",
            zIndex: 10,
          }),
          multiValue: (base) => ({
            ...base,
            background: "var(--input)",
            zIndex: MAX_Z_INDEX - 1,
          }),
          option: (base, state) => ({
            ...base,
            background: state.isSelected
              ? props?.custom
                ? "var(--white)"
                : "var(--primary)"
              : "var(--input)",
            color: state.isSelected
              ? props?.custom
                ? "var(--dark)"
                : "var(--white)"
              : base.color,
            "&:hover": {
              backgroundColor: state.isSelected
                ? "var(--primary)"
                : state.isFocused
                ? "#deebff"
                : "var(--primary)",
              color: props?.custom ? "var(--dark)" : "var(--white)",
            },
          }),
        }}
        {...props}
        placeholder={placeholder ?? t("select")}
      />
    </div>
  );
};

export default Select;